import React, { useEffect, useRef, useState } from 'react';
import Button from '../../Button/Button';
import './MenuFixed.scss';
import './MenuFixed-media.scss';
import { EnumUrlsPages } from '../../../services/Enum';
import MenuTop from '../MenuTop/MenuTop';
import {LKLinks, MenuTopList} from '../Header/constants'; // Fallback constants for when WordPress menus are not available
import MenuPopupDelivery from '../MenuPopupDelivery/MenuPopupDelivery';
import MenuPopupTeam from '../MenuPopupTeam/MenuPopupTeam';
import { createPortal } from 'react-dom';
import { GetHeightMenuFixed } from './functions';
import { Props } from './interfaces';
import LinkMenu from '../LinkMenu/LinkMenu';
import {content} from "../../../services/content";
import {ButtonOborot} from "../../ButtonsSpecial/ButtonsSpecial";
import Tel from "../../Tel/Tel";

const MenuFixed = ({ openFeedback, widthWindow, menu }: Props) => {
  const [visible, setVisible] = useState(false);

  // Build menu structure directly from HeaderMenu format
  const mainMenu: any[] = [];
  const lkMenu: any[] = [];

  // Services menu with popup
  if (menu.services) {
    mainMenu.push({
      text: menu.services.title,
      link: '',
      subComponent: ({ onClickLink }: { onClickLink: any }) => {
        return <MenuPopupDelivery
          onClickLink={onClickLink}
          showDelivery={false}
          showServices={true}
          servicesData={menu.services}
        />;
      },
      intoLink: false,
      hash: false
    });
  }

  // Calculator menu
  if (menu.calculator) {
    mainMenu.push({
      text: menu.calculator.title,
      link: menu.calculator.url,
      intoLink: false,
      hash: false
    });
  }

  // Geography menu with popup
  if (menu.geography) {
    mainMenu.push({
      text: menu.geography.title,
      link: '',
      subComponent: ({ onClickLink }: { onClickLink: any }) => {
        return <MenuPopupDelivery
          onClickLink={onClickLink}
          showDelivery={true}
          showServices={false}
          geographyData={menu.geography}
        />;
      },
      intoLink: false,
      hash: false
    });
  }

  // Blog menu
  if (menu.blog) {
    mainMenu.push({
      text: menu.blog.title,
      link: menu.blog.url,
      intoLink: false,
      hash: false,
      mark: true
    });
  }

  // Contacts menu with popup
  if (menu.contacts) {
    mainMenu.push({
      text: menu.contacts.title,
      link: menu.contacts.url,
      intoLink: false,
      hash: false,
      subComponent: ({ onClickLink }: { onClickLink: any }) => {
        return <MenuPopupTeam onClickLink={onClickLink} contactsData={menu.contacts} />;
      }
    });
  }

  // LK menu with submenu - flatten children array
  if (menu.lk && menu.lk.children) {
    const subMenuItems = menu.lk.children.flat()
      .filter((item: any) => item && item.title && item.url)
      .map((item: any) => ({
        text: item.title,
        link: item.url,
        intoLink: true,
        hash: false
      }));

    if (subMenuItems.length > 0) {
      lkMenu.push({
        text: menu.lk.title,
        link: '',
        subMenu: subMenuItems
      });
    }
  }

  const OpenFeedback = () => {
    closedMenu();
    openFeedback();
  };

  const [showMenu, setShowMenu] = useState(true);
  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  const closedMenu = () => {
    setShowMenu(false);
  };

  const refGap: any = useRef();
  const [heightGap, setHeightGap] = useState('auto');
  const handleScroll = () => {
    setHeightGap(GetHeightMenuFixed({ gap: refGap.current }));
    window.scrollY < 100 ? setVisible(false) : setVisible(true);
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const [mskPhone, setMskPhone] = useState<string | null>(null);
  const [spbPhone, setSpbPhone] = useState<string | null>(null);

  useEffect(() => {
    const mskElement = document.querySelector('.mgo_num_msk');
    const spbElement = document.querySelector('.mgo_num_spb');
    if (!mskElement || !spbElement) {
      return;
    }

    const updateMskPhone = () => {
      if (mskElement) {
        setMskPhone(mskElement.textContent);
      }
    };

    const updateSpbPhone = () => {
      if (spbElement) {
        setSpbPhone(spbElement.textContent);
      }
    };

    // Initial fetch
    updateMskPhone();
    updateSpbPhone();

    // Create MutationObservers
    const mskObserver = new MutationObserver(updateMskPhone);
    const spbObserver = new MutationObserver(updateSpbPhone);

    if (mskElement) {
      mskObserver.observe(mskElement, { childList: true, subtree: true });
    }

    if (spbElement) {
      spbObserver.observe(spbElement, { childList: true, subtree: true });
    }

    // Cleanup observers on unmount
    return () => {
      mskObserver.disconnect();
      spbObserver.disconnect();
    };
  }, []);

  return createPortal(
    <div className="space-menu">
      <div className="space-menu__gap" ref={refGap} />
      <div className="space-menu__wrapper" style={{ height: heightGap }}>
        <div
          className="menu-fixed"
          style={visible ? { opacity: '1', pointerEvents: 'all' } : { opacity: '0', pointerEvents: 'none' }}
        >
          {showMenu && (
            <>
              <div className="menu-fixed__bg" onClick={closedMenu} />
              <div className="menu-fixed__container">
                <div className="header__top">
                  <ButtonOborot widthWindow={widthWindow} />
                  <div className="header__contacts">
                    {mskPhone && <section className="header__contacts-link">
                      <Tel className={'mgo_num_msk'} phone={content.header.textCity1Number} /> <span>{content.header.textCity1}</span>
                    </section>}
                    {spbPhone && <section className="header__contacts-link">
                      <Tel className={'mgo_num_spb'} phone={content.header.textCity2Number} /> <span>{content.header.textCity2}</span>
                    </section>}
                    <section className="header__contacts-link">
                      <span>{content.header.textWorkSchedule}</span>
                    </section>
                    <section className="header__contacts-link">
                      <MenuTop menu={lkMenu.length > 0 ? lkMenu : LKLinks} />
                    </section>
                  </div>
                </div>
                <div className={`menu-fixed__content`}>
                  <LinkMenu
                    menu={{ text: content.header.textsMenu.main, link: '/', intoLink: false, hash: false }}
                    onClickLink={closedMenu}
                  />
                  <MenuTop menu={mainMenu.length > 0 ? mainMenu : MenuTopList} onClickLink={closedMenu} />

                  <div className="header__buttons">
                    <Button
                      text={content.header.textTracking}
                      link={EnumUrlsPages.tracking}
                      onClick={closedMenu}
                      type="border"
                      size="S"
                      widthAll
                    />
                    <Button text={content.header.textModalFeedback} onClick={OpenFeedback} size="S" widthAll />
                  </div>
                </div>
              </div>
            </>
          )}

          <div
            className={`menu-fixed__button${showMenu ? ' menu-fixed__button_active' : ''}`}
            onClick={toggleMenu}
          >
            <div
              className={`menu-fixed__hamburger${
                showMenu ? ' menu-fixed__hamburger_open' : ' menu-fixed__hamburger_close'
              }`}
            >
              <span className="menu-fixed__hamburger-line line1" />
              <span className="menu-fixed__hamburger-line line2" />
              <span className="menu-fixed__hamburger-line line3" />
            </div>
            <p>{content.header.textMenu}</p>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default MenuFixed;
